import React from 'react';
import { Card } from '../components/ui';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from '../hooks/useTranslation';
import { ArrowBack, Email, Handshake, Business, TrendingUp, Group, Analytics, Shield, Campaign, Star } from '../mui-icons';
import './PartnershipsPage.css';

const PartnershipsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleContact = () => {
    window.location.href = 'mailto:vinicius.meggiotto@womm.com.br?subject=Parceria PersonalNutri';
  };

  return (
    <div className="partnerships-page surface-marketing">
      <Header />

      {/* Header Verde */}
      <section className="partnerships-header-section">
        <div className="container">
          <div className="partnerships-header-content">
            <Handshake sx={{ fontSize: 60 }} />
            <h1 className="partnerships-main-title">{t('partnerships.hero.title')}</h1>
            <p className="partnerships-main-subtitle">
              {t('partnerships.hero.subtitle')}
            </p>
          </div>
        </div>
      </section>

      <div className="container partnerships-container">
        {/* Card de Contato */}
        <section className="partnerships-card pn-card pn-card--marketing">
          <div className="partnerships-card-icon">
            <Email sx={{ fontSize: 48 }} />
          </div>
          <h2 className="partnerships-card-title">{t('partnerships.contact.title')}</h2>
          <p className="partnerships-card-text">
            {t('partnerships.contact.text')}
          </p>
          <button onClick={handleContact} className="contact-button">
            <Email />
            {t('partnerships.contact.button')}
          </button>
        </section>

        {/* Tipos de Parceria */}
        <section className="partnership-types">
          <h2 className="section-title">{t('partnerships.types.title')}</h2>
          <p className="section-subtitle">
            {t('partnerships.types.subtitle')}
          </p>

          <div className="partnership-grid">
            {/* Featured Partnerships */}
            <div className="partnership-type-card featured">
              <div className="featured-badge">
                <Star sx={{ fontSize: 14, marginRight: '4px' }} />
{t('partnerships.types.featured')}
              </div>
              <div className="partnership-icon">
                <Analytics sx={{ fontSize: 40 }} />
              </div>
              <h3 className="partnership-title">{t('partnerships.types.marketIntelligence.title')}</h3>
              <p className="partnership-description">
                <strong>{t('partnerships.types.marketIntelligence.highlight')}</strong> {t('partnerships.types.marketIntelligence.description')}
              </p>
              <ul className="partnership-benefits">
                {t('partnerships.types.marketIntelligence.benefits').map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
              <div className="data-protection-note">
                <Shield sx={{ fontSize: 20 }} />
                <span>{t('partnerships.types.marketIntelligence.protection')}</span>
              </div>
              <a 
                href="mailto:vinicius.meggiotto@womm.com.br?subject=Parceria: Inteligência de Mercado - PersonalNutri" 
                className="partnership-contact-button"
              >
                <Email sx={{ fontSize: 18 }} />
{t('partnerships.types.marketIntelligence.button')}
              </a>
            </div>

            <div className="partnership-type-card featured">
              <div className="featured-badge">
                <Star sx={{ fontSize: 14, marginRight: '4px' }} />
{t('partnerships.types.featured')}
              </div>
              <div className="partnership-icon">
                <Campaign sx={{ fontSize: 40 }} />
              </div>
              <h3 className="partnership-title">{t('partnerships.types.influencers.title')}</h3>
              <p className="partnership-description">
                <strong>{t('partnerships.types.influencers.highlight')}</strong> {t('partnerships.types.influencers.description')}
              </p>
              <ul className="partnership-benefits">
                {t('partnerships.types.influencers.benefits').map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
              <div className="data-protection-note influencer">
                <Star sx={{ fontSize: 20 }} />
                <span>{t('partnerships.types.influencers.program')}</span>
              </div>
              <a 
                href="mailto:vinicius.meggiotto@womm.com.br?subject=Parceria: Influenciadores - PersonalNutri" 
                className="partnership-contact-button"
              >
                <Email sx={{ fontSize: 18 }} />
{t('partnerships.types.influencers.button')}
              </a>
            </div>

            <div className="partnership-type-card pn-card pn-card--marketing">
              <div className="partnership-icon">
                <Business sx={{ fontSize: 40 }} />
              </div>
              <h3 className="partnership-title">{t('partnerships.types.strategic.title')}</h3>
              <p className="partnership-description">
                {t('partnerships.types.strategic.description')}
              </p>
              <ul className="partnership-benefits">
                {t('partnerships.types.strategic.benefits').map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
              <a 
                href="mailto:vinicius.meggiotto@womm.com.br?subject=Parceria Estratégica - PersonalNutri" 
                className="partnership-contact-button"
              >
                <Email sx={{ fontSize: 18 }} />
{t('partnerships.types.strategic.button')}
              </a>
            </div>

            <div className="partnership-type-card pn-card pn-card--marketing">
              <div className="partnership-icon">
                <TrendingUp sx={{ fontSize: 40 }} />
              </div>
              <h3 className="partnership-title">{t('partnerships.types.affiliates.title')}</h3>
              <p className="partnership-description">
                {t('partnerships.types.affiliates.description')}
              </p>
              <ul className="partnership-benefits">
                {t('partnerships.types.affiliates.benefits').map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
              <a 
                href="mailto:vinicius.meggiotto@womm.com.br?subject=Programa de Afiliados - PersonalNutri" 
                className="partnership-contact-button"
              >
                <Email sx={{ fontSize: 18 }} />
{t('partnerships.types.affiliates.button')}
              </a>
            </div>

            <div className="partnership-type-card pn-card pn-card--marketing">
              <div className="partnership-icon">
                <Group sx={{ fontSize: 40 }} />
              </div>
              <h3 className="partnership-title">{t('partnerships.types.institutional.title')}</h3>
              <p className="partnership-description">
                {t('partnerships.types.institutional.description')}
              </p>
              <ul className="partnership-benefits">
                {t('partnerships.types.institutional.benefits').map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
              <a 
                href="mailto:vinicius.meggiotto@womm.com.br?subject=Parceria Institucional - PersonalNutri" 
                className="partnership-contact-button"
              >
                <Email sx={{ fontSize: 18 }} />
{t('partnerships.types.institutional.button')}
              </a>
            </div>
          </div>
        </section>

        {/* Informações de Contato */}
        <section className="contact-info">
          <h2 className="section-title">{t('partnerships.contactInfo.title')}</h2>
          <div className="contact-details">
            <div className="contact-item">
              <Email className="contact-icon" />
              <div className="contact-info-text">
                <strong>{t('partnerships.contactInfo.emailLabel')}</strong>
                <a href="mailto:vinicius.meggiotto@womm.com.br?subject=Parceria PersonalNutri" className="email-link">
                  {t('partnerships.contactInfo.emailLink')}
                </a>
              </div>
            </div>
            <div className="contact-item">
              <Handshake className="contact-icon" />
              <div className="contact-info-text">
                <strong>{t('partnerships.contactInfo.subjectLabel')}</strong>
                <span>{t('partnerships.contactInfo.subjectText')}</span>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default PartnershipsPage;
